import { useGlobalContext } from "@/global/GlobalContext"
import { Navigate } from "react-router-dom"
import { menu } from "@/app/utils/constants"

export const AuthRoute = ({ Component }) => {
  const { authStore } = useGlobalContext()

  return authStore.isAuth ? <Component /> : <Navigate to="/auth/login" replace />
}

export const UnAuthRoute = ({ Component }) => {
  const { authStore } = useGlobalContext()

  return !authStore.isAuth ? <Component /> : <Navigate to="/" replace />
}

export const AccessResetPass = ({ Component }) => {
  const queryStr = window.location.search
  const urlParams = new URLSearchParams(queryStr)
  const [token, email] = [urlParams.get("token"), urlParams.get("email")];

  return (token && email) ? <Component /> : <Navigate to="/auth/login" replace />
}

export const UnRegis = ({ Component }) => {
  const { authStore } = useGlobalContext()

  return (authStore.registered && !authStore.isAuth) ? <Component /> : <Navigate to="/auth/registration" replace />
}

export const UnReleased = () => {
  return <Navigate to="/coming-soon" replace />
}

export const RedirectToContactUs = () => {
  return <Navigate to={menu[9].link} replace />
}